module.exports = __webpack_public_path__ + "img/20190528161815QQ截图20190527165231.703121bf.png";